module.exports = __webpack_public_path__ + "img/haider_ahmed_ibm2-min.9eca5dda.jpg";